import * as __WEBPACK_EXTERNAL_MODULE_axios__ from "axios";
var Api_WorkspaceRoles = /*#__PURE__*/ function(WorkspaceRoles) {
    WorkspaceRoles["WorkspaceLevelOwner"] = "workspace-level-owner";
    WorkspaceRoles["WorkspaceLevelCreator"] = "workspace-level-creator";
    WorkspaceRoles["WorkspaceLevelEditor"] = "workspace-level-editor";
    WorkspaceRoles["WorkspaceLevelViewer"] = "workspace-level-viewer";
    WorkspaceRoles["WorkspaceLevelCommenter"] = "workspace-level-commenter";
    WorkspaceRoles["WorkspaceLevelNoAccess"] = "workspace-level-no-access";
    return WorkspaceRoles;
}({});
var Api_BaseRoles = /*#__PURE__*/ function(BaseRoles) {
    BaseRoles["Owner"] = "owner";
    BaseRoles["Creator"] = "creator";
    BaseRoles["Editor"] = "editor";
    BaseRoles["Viewer"] = "viewer";
    BaseRoles["Commenter"] = "commenter";
    BaseRoles["NoAccess"] = "no-access";
    return BaseRoles;
}({});
var Api_ViewAggregationEnum = /*#__PURE__*/ function(ViewAggregationEnum) {
    ViewAggregationEnum["Sum"] = "sum";
    ViewAggregationEnum["Min"] = "min";
    ViewAggregationEnum["Max"] = "max";
    ViewAggregationEnum["Avg"] = "avg";
    ViewAggregationEnum["Median"] = "median";
    ViewAggregationEnum["StdDev"] = "std_dev";
    ViewAggregationEnum["Range"] = "range";
    ViewAggregationEnum["Count"] = "count";
    ViewAggregationEnum["CountEmpty"] = "count_empty";
    ViewAggregationEnum["CountFilled"] = "count_filled";
    ViewAggregationEnum["CountUnique"] = "count_unique";
    ViewAggregationEnum["PercentEmpty"] = "percent_empty";
    ViewAggregationEnum["PercentFilled"] = "percent_filled";
    ViewAggregationEnum["PercentUnique"] = "percent_unique";
    ViewAggregationEnum["None"] = "none";
    ViewAggregationEnum["AttachmentSize"] = "attachment_size";
    ViewAggregationEnum["Checked"] = "checked";
    ViewAggregationEnum["Unchecked"] = "unchecked";
    ViewAggregationEnum["PercentChecked"] = "percent_checked";
    ViewAggregationEnum["PercentUnchecked"] = "percent_unchecked";
    ViewAggregationEnum["EarliestDate"] = "earliest_date";
    ViewAggregationEnum["LatestDate"] = "latest_date";
    ViewAggregationEnum["DateRange"] = "date_range";
    ViewAggregationEnum["MonthRange"] = "month_range";
    return ViewAggregationEnum;
}({});
var Api_ContentType = /*#__PURE__*/ function(ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
    return ContentType;
}({});
class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}){
        this.instance = __WEBPACK_EXTERNAL_MODULE_axios__["default"].create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "https://app.nocodb.com"
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data)=>{
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || params2 && params2.method;
        return {
            ...this.instance.defaults,
            ...params1,
            ...params2 || {},
            headers: {
                ...method && this.instance.defaults.headers[method.toLowerCase()] || {},
                ...params1.headers || {},
                ...params2 && params2.headers || {}
            }
        };
    }
    stringifyFormItem(formItem) {
        if ("object" == typeof formItem && null !== formItem) return JSON.stringify(formItem);
        return `${formItem}`;
    }
    createFormData(input) {
        if (input instanceof FormData) return input;
        return Object.keys(input || {}).reduce((formData, key)=>{
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [
                property
            ];
            for (const formItem of propertyContent){
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params })=>{
        const secureParams = ("boolean" == typeof secure ? secure : this.secure) && this.securityWorker && await this.securityWorker(this.securityData) || {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || void 0;
        if ("multipart/form-data" === type && body && null !== body && "object" == typeof body) body = this.createFormData(body);
        if ("text/plain" === type && body && null !== body && "string" != typeof body) body = JSON.stringify(body);
        return this.instance.request({
            ...requestParams,
            headers: {
                ...requestParams.headers || {},
                ...type ? {
                    "Content-Type": type
                } : {}
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path
        }).then((response)=>response.data);
    };
}
class InternalApi extends HttpClient {
    api = {
        workspaceList: (params = {})=>this.request({
                path: "/api/v3/meta/workspaces",
                method: "GET",
                format: "json",
                ...params
            }),
        workspaceCreate: (data, params = {})=>this.request({
                path: "/api/v3/meta/workspaces",
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        workspaceRead: (workspaceId, query, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}`,
                method: "GET",
                query: query,
                format: "json",
                ...params
            }),
        workspaceUpdate: (workspaceId, data, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        workspaceDelete: (workspaceId, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}`,
                method: "DELETE",
                ...params
            }),
        basesList: (workspaceId, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}/bases`,
                method: "GET",
                format: "json",
                ...params
            }),
        baseCreate: (workspaceId, data, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}/bases`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        workspaceMembersRead: (workspaceId, query, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}?include[]=members`,
                method: "GET",
                query: query,
                format: "json",
                ...params
            }),
        workspaceMembersInvite: (workspaceId, data, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}/members`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        workspaceMembersUpdate: (workspaceId, data, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}/members`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        workspaceMembersDelete: (workspaceId, data, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}/members`,
                method: "DELETE",
                body: data,
                type: "application/json",
                ...params
            }),
        baseRead: (baseId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}`,
                method: "GET",
                format: "json",
                ...params
            }),
        baseUpdate: (baseId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        baseDelete: (baseId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}`,
                method: "DELETE",
                ...params
            }),
        tablesList: (baseId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/tables`,
                method: "GET",
                format: "json",
                ...params
            }),
        tableCreate: (baseId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/tables`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        tableRead: (tableId, baseId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/tables/${tableId}`,
                method: "GET",
                format: "json",
                ...params
            }),
        tableUpdate: (tableId, baseId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/tables/${tableId}`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        tableDelete: (baseId, tableId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/tables/${tableId}`,
                method: "DELETE",
                ...params
            }),
        viewsList: (baseId, tableId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/tables/${tableId}/views`,
                method: "GET",
                format: "json",
                ...params
            }),
        viewCreate: (baseId, tableId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/tables/${tableId}/views`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        fieldCreate: (tableId, baseId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/tables/${tableId}/fields`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        fieldRead: (baseId, fieldId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/fields/${fieldId}`,
                method: "GET",
                format: "json",
                ...params
            }),
        fieldUpdate: (baseId, fieldId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/fields/${fieldId}`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        fieldDelete: (fieldId, baseId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/fields/${fieldId}`,
                method: "DELETE",
                ...params
            }),
        hooksList: (baseId, tableId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/tables/${tableId}/hooks`,
                method: "GET",
                format: "json",
                ...params
            }),
        hookCreate: (baseId, tableId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/tables/${tableId}/hooks`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        hookRead: (baseId, hookId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/hooks/${hookId}`,
                method: "GET",
                format: "json",
                ...params
            }),
        hookUpdate: (baseId, hookId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/hooks/${hookId}`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        hookDelete: (baseId, hookId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/hooks/${hookId}`,
                method: "DELETE",
                ...params
            }),
        viewRead: (baseId, viewId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/views/${viewId}`,
                method: "GET",
                format: "json",
                ...params
            }),
        viewUpdate: (baseId, viewId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/views/${viewId}`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        viewDelete: (baseId, viewId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/views/${viewId}`,
                method: "DELETE",
                ...params
            }),
        viewFiltersList: (baseId, viewId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/views/${viewId}/filters`,
                method: "GET",
                format: "json",
                ...params
            }),
        viewFilterCreate: (baseId, viewId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/views/${viewId}/filters`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        viewFilterReplace: (baseId, viewId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/views/${viewId}/filters`,
                method: "PUT",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        viewFilterUpdate: (baseId, filterId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/filters/${filterId}`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        viewFilterDelete: (baseId, filterId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/filters/${filterId}`,
                method: "DELETE",
                ...params
            }),
        viewSortsList: (baseId, viewId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/views/${viewId}/sorts`,
                method: "GET",
                format: "json",
                ...params
            }),
        viewSortCreate: (baseId, viewId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/views/${viewId}/sorts`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        viewSortDelete: (baseId, sortId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/sorts/${sortId}`,
                method: "DELETE",
                ...params
            }),
        viewSortUpdate: (baseId, sortId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/sorts/${sortId}`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        baseMembersList: (baseId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}?include[]=members`,
                method: "GET",
                format: "json",
                ...params
            }),
        baseMembersInvite: (baseId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/members`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        baseMembersUpdate: (baseId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/members`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        baseMembersDelete: (baseId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/members`,
                method: "DELETE",
                body: data,
                type: "application/json",
                ...params
            }),
        scriptsList: (baseId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/scripts`,
                method: "GET",
                format: "json",
                ...params
            }),
        scriptCreate: (baseId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/scripts`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        scriptRead: (scriptId, baseId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/scripts/${scriptId}`,
                method: "GET",
                format: "json",
                ...params
            }),
        scriptUpdate: (scriptId, baseId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/scripts/${scriptId}`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        scriptDelete: (scriptId, baseId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/scripts/${scriptId}`,
                method: "DELETE",
                ...params
            }),
        dashboardsList: (baseId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/dashboards`,
                method: "GET",
                format: "json",
                ...params
            }),
        dashboardCreate: (baseId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/dashboards`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        dashboardRead: (baseId, dashboardId, query, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/dashboards/${dashboardId}`,
                method: "GET",
                query: query,
                format: "json",
                ...params
            }),
        dashboardUpdate: (baseId, dashboardId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/dashboards/${dashboardId}`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        dashboardDelete: (baseId, dashboardId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/dashboards/${dashboardId}`,
                method: "DELETE",
                ...params
            }),
        dashboardDataRead: (baseId, dashboardId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/dashboards/${dashboardId}/data`,
                method: "GET",
                format: "json",
                ...params
            }),
        widgetsList: (baseId, dashboardId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/dashboards/${dashboardId}/widgets`,
                method: "GET",
                format: "json",
                ...params
            }),
        widgetCreate: (baseId, dashboardId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/dashboards/${dashboardId}/widgets`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        widgetRead: (baseId, dashboardId, widgetId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/dashboards/${dashboardId}/widgets/${widgetId}`,
                method: "GET",
                format: "json",
                ...params
            }),
        widgetUpdate: (baseId, dashboardId, widgetId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/dashboards/${dashboardId}/widgets/${widgetId}`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        widgetDelete: (baseId, dashboardId, widgetId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/dashboards/${dashboardId}/widgets/${widgetId}`,
                method: "DELETE",
                ...params
            }),
        widgetDataRead: (baseId, dashboardId, widgetId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/dashboards/${dashboardId}/widgets/${widgetId}/data`,
                method: "GET",
                format: "json",
                ...params
            }),
        workflowsList: (baseId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/workflows`,
                method: "GET",
                format: "json",
                ...params
            }),
        workflowRead: (baseId, workflowId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/workflows/${workflowId}`,
                method: "GET",
                format: "json",
                ...params
            }),
        workflowExecute: (baseId, workflowId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/workflows/${workflowId}/execute`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        workflowExecutionList: (baseId, workflowId, query, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/workflows/${workflowId}/executions`,
                method: "GET",
                query: query,
                format: "json",
                ...params
            }),
        workflowExecutionRead: (baseId, workflowId, executionId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/workflows/${workflowId}/executions/${executionId}`,
                method: "GET",
                format: "json",
                ...params
            }),
        dbDataTableRowList: (baseId, tableId, query, params = {})=>this.request({
                path: `/api/v3/data/${baseId}/${tableId}/records`,
                method: "GET",
                query: query,
                format: "json",
                ...params
            }),
        dbDataTableRowCreate: (baseId, tableId, data, params = {})=>this.request({
                path: `/api/v3/data/${baseId}/${tableId}/records`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        dbDataTableRowUpdate: (baseId, tableId, data, params = {})=>this.request({
                path: `/api/v3/data/${baseId}/${tableId}/records`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        dbDataTableRowDelete: (baseId, tableId, data, params = {})=>this.request({
                path: `/api/v3/data/${baseId}/${tableId}/records`,
                method: "DELETE",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        dbV3DataTableRowUpsert: (baseId, tableId, data, params = {})=>this.request({
                path: `/api/v3/data/${baseId}/${tableId}/records/upsert`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        dbDataTableRowRead: (baseId, tableId, recordId, query, params = {})=>this.request({
                path: `/api/v3/data/${baseId}/${tableId}/records/${recordId}`,
                method: "GET",
                query: query,
                format: "json",
                ...params
            }),
        dbDataTableRowAttachmentUpload: (baseId, modelId, recordId, fieldId, data, params = {})=>this.request({
                path: `/api/v3/data/${baseId}/${modelId}/records/${recordId}/fields/${fieldId}/upload`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        dbDataTableRowCount: (baseId, tableId, query, params = {})=>this.request({
                path: `/api/v3/data/${baseId}/${tableId}/count`,
                method: "GET",
                query: query,
                format: "json",
                ...params
            }),
        dbDataTableRowNestedList: (tableId, linkFieldId, recordId, baseId, query, params = {})=>this.request({
                path: `/api/v3/data/${baseId}/${tableId}/links/${linkFieldId}/${recordId}`,
                method: "GET",
                query: query,
                format: "json",
                ...params
            }),
        dbDataTableRowNestedLink: (tableId, linkFieldId, recordId, baseId, data, params = {})=>this.request({
                path: `/api/v3/data/${baseId}/${tableId}/links/${linkFieldId}/${recordId}`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        dbDataTableRowNestedUnlink: (tableId, linkFieldId, recordId, baseId, data, params = {})=>this.request({
                path: `/api/v3/data/${baseId}/${tableId}/links/${linkFieldId}/${recordId}`,
                method: "DELETE",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        triggerAction: (baseId, tableId, columnId, data, params = {})=>this.request({
                path: `/api/v3/data/${baseId}/${tableId}/actions/${columnId}`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        teamsListV3: (workspaceId, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}/teams`,
                method: "GET",
                format: "json",
                ...params
            }),
        teamsCreateV3: (workspaceId, data, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}/teams`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        teamsGetV3: (workspaceId, teamId, query, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}/teams/${teamId}`,
                method: "GET",
                query: query,
                format: "json",
                ...params
            }),
        teamsUpdateV3: (workspaceId, teamId, data, query, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}/teams/${teamId}`,
                method: "PATCH",
                query: query,
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        teamsDeleteV3: (workspaceId, teamId, query, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}/teams/${teamId}`,
                method: "DELETE",
                query: query,
                format: "json",
                ...params
            }),
        teamsMembersAddV3: (workspaceId, teamId, data, query, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}/teams/${teamId}/members`,
                method: "POST",
                query: query,
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        teamsMembersRemoveV3: (workspaceId, teamId, data, query, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}/teams/${teamId}/members`,
                method: "DELETE",
                query: query,
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        teamsMembersUpdateV3: (workspaceId, teamId, data, query, params = {})=>this.request({
                path: `/api/v3/meta/workspaces/${workspaceId}/teams/${teamId}/members`,
                method: "PATCH",
                query: query,
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        v3MetaTokensList: (params = {})=>this.request({
                path: "/api/v3/meta/tokens",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            }),
        v3MetaTokensCreate: (data, params = {})=>this.request({
                path: "/api/v3/meta/tokens",
                method: "POST",
                body: data,
                secure: true,
                type: "application/json",
                format: "json",
                ...params
            }),
        v3MetaTokensDelete: (tokenId, params = {})=>this.request({
                path: `/api/v3/meta/tokens/${tokenId}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params
            }),
        documentList: (baseId, query, params = {})=>this.request({
                path: `/api/v3/docs/${baseId}`,
                method: "GET",
                query: query,
                format: "json",
                ...params
            }),
        documentCreate: (baseId, data, params = {})=>this.request({
                path: `/api/v3/docs/${baseId}`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        documentRead: (baseId, docId, params = {})=>this.request({
                path: `/api/v3/docs/${baseId}/${docId}`,
                method: "GET",
                format: "json",
                ...params
            }),
        documentUpdate: (baseId, docId, data, params = {})=>this.request({
                path: `/api/v3/docs/${baseId}/${docId}`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        documentDelete: (baseId, docId, params = {})=>this.request({
                path: `/api/v3/docs/${baseId}/${docId}`,
                method: "DELETE",
                format: "json",
                ...params
            }),
        documentReorder: (baseId, docId, data, params = {})=>this.request({
                path: `/api/v3/docs/${baseId}/${docId}/reorder`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        commentsList: (baseId, tableId, recordId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/tables/${tableId}/records/${recordId}/comments`,
                method: "GET",
                format: "json",
                ...params
            }),
        commentsCreate: (baseId, tableId, recordId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/tables/${tableId}/records/${recordId}/comments`,
                method: "POST",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        commentsUpdate: (baseId, commentId, data, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/comments/${commentId}`,
                method: "PATCH",
                body: data,
                type: "application/json",
                format: "json",
                ...params
            }),
        commentsDelete: (baseId, commentId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/comments/${commentId}`,
                method: "DELETE",
                format: "json",
                ...params
            }),
        commentsResolve: (baseId, commentId, params = {})=>this.request({
                path: `/api/v3/meta/bases/${baseId}/comments/${commentId}/resolve`,
                method: "POST",
                format: "json",
                ...params
            })
    };
}
export { Api_BaseRoles as BaseRoles, Api_ContentType as ContentType, HttpClient, InternalApi, Api_ViewAggregationEnum as ViewAggregationEnum, Api_WorkspaceRoles as WorkspaceRoles };
